module.exports = __webpack_public_path__ + "img/SK.21617d97.svg";